<template>
  <div class="page-back-title" :class="{ 'page-back-title--large': large }">
    <span class="back-btn" @click="handleBack">
      <a-icon type="left" />
      返回
    </span>
    <span class="title">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: 'PageBackTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleBack () {
      if (this.$listeners.back) {
        this.$emit('back')
        return
      }
      this.$router.back()
    }
  }
}
</script>

<style scoped lang="less">
.page-back-title {
  display: flex;
  align-items: center;

  &--large {
    margin-bottom: 16px;

    .title {
      font-size: 20px;
      font-weight: 600;
    }
  }
}

.back-btn {
  display: inline-flex;
  align-items: center;
  margin-right: 32px;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  user-select: none;

  &:hover {
    color: #faad14;
  }

  .anticon {
    margin-right: 4px;
  }
}

.title {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}
</style>
